export default [

    {
        path: '/translations',
        name: 'translation-list',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'6', subMenuActive:'1', title: 'headers.translations-title'},
        components: {
            default: () => import(/* webpackChunkName: "root" */ './views/translation-list'),
            'section-header': () => import(/* webpackChunkName: "root" */ './components/section-header')
        }
    },

    {
        path: '/existing-translations',
        name: 'translation-existing-list',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'6', subMenuActive:'2', title: 'headers.translations-existing-title'},
        components: {
            default: () => import(/* webpackChunkName: "root" */ './views/translation-existing-list'),
            'section-header': () => import(/* webpackChunkName: "root" */ './components/section-header')
        }
    },

];